// extracted by mini-css-extract-plugin
module.exports = {"greenCard":"GreenCardNum_greenCard__1KdBA","greenNum":"GreenCardNum_greenNum__3WZj0","bg":"GreenCardNum_bg__156Uw"};